import type Category from '../types/category';
import type { BreadcrumbLink } from '../components/LinkBreadcrumbs';

interface LookupTable {
    [key: string]: Category;
}

// transforms flatten categories list to tree-like structure
export const buildTree = (list: Omit<Category, 'children'>[]) => {
    const tree: Category[] = [];
    const lookup: LookupTable = {};

    list.forEach(obj => {
        lookup[obj.id] = {
            ...obj,
            children: [],
        };
    });
    list.forEach(obj => {
        if (obj.parentId) {
            lookup[obj.parentId].children.push(lookup[obj.id]);
        } else {
            tree.push(lookup[obj.id]);
        }
    });
    return tree;
};

export const buildBreadcrumbs = (category: Category) => {
    return category.path.map(({ name, id }) => ({
        name,
        id,
    }));
};

export const buildCategoryBreadcrumbs = (
    category?: Category,
    search = ''
): BreadcrumbLink[] => {
    if (!category) {
        return [];
    }
    return category.path.map(({ name, id }) => ({
        label: name,
        to: `/categories/${id}${search}`,
    }));
};

export const fromRootLinkToBreadcrumbs = (
    rootLinks?: {
        text?: string;
        messageId?: string;
        to?: string;
    }[]
) => {
    return (
        rootLinks?.map(rootLink => {
            return {
                label: rootLink.text,
                labelId: rootLink.messageId,
                to: rootLink.to,
            };
        }) || []
    );
};
